<template>
<section>
    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
        <div class="box">
            <div class="box-body">
                <div class="row">
                    <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                    </div>
                </div>
                <div id="details" class="row">
                    <div class="row">
                        <vue-form :state="formstate">
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.startDate)">
                                        <label>Start Date </label>
                                        <date-picker id="startDate" v-model="data.startDate" @change="datevalidation" lang="en" name="startDate" required :not-after="disabledStartDate" input-class="form-control" width="100%" valueType="format" :format="'DD-MM-YYYY'"></date-picker>
                                        <field-messages name="startDate" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">This is required field</div>
                                        </field-messages>
                                    </validate>

                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.endDate)">
                                        <label>End Date </label>
                                        <date-picker :not-before="notBeforeEndDate" @change="datevalidation1" id="endDate" v-model="data.endDate" :not-after="disabledAfter" lang="en" :disabled="isEndDateDisable" name="endDate" required input-class="form-control" width="100%" valueType="format" :format="'DD-MM-YYYY'"></date-picker>
                                        <field-messages name="endDate" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">This is required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>

                        </vue-form>
                        <div class="form-actions">
                            <button type="submit" @click="createCSV" :disabled="!(formstate.$dirty && formstate.$valid)" v-bind:class="'mr-2 btn gradientbt'">
                                Download CSV
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import store from '../../../store';
import {
    formService,
    eventBus,
    exportcsvService
} from '../../../services'
import {
    EVENTS
} from '../../../config'
import {
    USER_ROLES
} from '../../../config';
import moment from "moment";

export default {
    name: 'csvexport',

    data() {
        return {
            isEndDateDisable: true,
            disabledStartDate: new Date(),
            disabledAfter: null,
            notBeforeEndDate: new Date(),
            //data: {},
            ready: false,
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            formstate: {},
            oldData: {},
            endDateIso: "",
            startDateIso: "",
        }
    },
    props: ['type', 'data'],

    watch: {
        data: function (newVal, oldVal) { // watch it
            if (!Object.keys(newVal).length) {
                this.formstate._reset();
                this.isEndDateDisable = true;
            }
        }
    },

    methods: {
        fieldClassName: formService.fieldClassName,
        createCSV() {
            this.data['type'] = this.type;
            this.data['startDateIso'] = this.startDateIso;
            this.data['endDateIso'] = this.endDateIso;         

            return exportcsvService
                .getCSV(this.data)
                .then((response) => {
                    // this.$refs.inputFile.reset();
                   
                    this.$snotify.success(
                        `The CSV has been downloaded successfully.`
                    );

                })
                .catch((error) => {
                    this.$snotify.error(error, "Error!");
                });
        },
        datevalidation(event) {        
            const eventData = event.split("-");
            const startDate = eventData[1] + "-" + eventData[0] + "-" + eventData[2];
            this.notBeforeEndDate = startDate;
            let endDate = new Date(startDate);
            this.disabledAfter = new Date(endDate.setMonth(endDate.getMonth() + 3));
            this.isEndDateDisable = false;

            let date = new Date(startDate);
            this.startDateIso = moment(date).format('YYYY-MM-DDTHH:mm:ss') 

        },

        datevalidation1(event) {  
            const eventData = event.split("-");
            const startDate = eventData[1] + "-" + eventData[0] + "-" + eventData[2];         
            let date = new Date(startDate);
            this.endDateIso = moment(date).format('YYYY-MM-DDTHH:mm:ss')    
 
        },

        clearChanges() {
            this.data = _.cloneDeep(this.oldData);
            this.formstate._reset();
        },
    },

    fieldClassName: function (field) {
        if (!field) {
            return '';
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return 'has-success';
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return 'has-danger';
        }
    },

}
</script>

<style scoped>
.required-field>label::after {
    content: '*';
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red
}

.mt {
    margin-top: 7px;
}

.gradientbt {
    background: #35A2FE;
    color: white
}

.inputwrapper {
    position: relative;
}

.maps {
    position: absolute;
    top: 7px;
    right: 10px;
}
.modal-body {
    position: relative;
    padding: 15px;
    height: 178px;
}
</style>



// WEBPACK FOOTER //
// csvexport.vue?0efa4cb6